import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import ProductBrowse from './pages/ProductBrowse';
import ApplicationForm from './pages/ApplicationForm';
import MyApplications from './pages/MyApplications';
import FeedbackForm from './pages/FeedbackForm';
import AdminPage from './pages/AdminPage';
import AdminDashboard from './pages/AdminDashboard';
import ProductManagement from './pages/ProductManagement';
import ProductApplications from './pages/ProductApplications';
import AdminFeedback from './pages/AdminFeedback';
import ProductFeedback from './pages/ProductFeedback';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/register" element={<LoginPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/apply" element={<ProductBrowse />} />
        <Route path="/apply-form" element={<ApplicationForm />} />
        <Route path="/my-applications" element={<MyApplications />} />
        <Route path="/feedback" element={<FeedbackForm />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/products" element={<ProductManagement />} />
        <Route path="/product-applications/:productId" element={<ProductApplications />} />
        <Route path="/product-feedback/:productId" element={<ProductFeedback />} />
        <Route path="/admin-feedback" element={<AdminFeedback />} />
      </Routes>
    </Router>
  );
}

export default App;